<template>
  <USelectMenu
    v-model="modelValue"
    :items="lessonTypes"
    :class="ui?.root"
    class="select-menu pl-5 displ max-w-43.5 min-w-43.5 shrink grow-0"
    label-key="name"
    multiple
    :search-input="{
      icon: 'i-local-search',
      loadingIcon: 'w-4 h-4',
      placeholder: 'Поиск',
    }"
    :ui="{
      trailingIcon:
        'group-data-[state=open]:rotate-180 transition-transform duration-200 text-neutral-default w-6 h-6',
      itemTrailingIcon: 'hidden',
      content: 'w-80',
    }"
  >
    <template #item-leading="{ item }">
      <UCheckbox
        :model-value="isLessonTypeSelected(item as LessonTypeRef)"
        :ui="{
          root: 'pointer-events-none',
          base: 'w-5 h-5 ring-neutral-border-default ring-2 bg-background-bg1',
          icon: 'h-4 w-4',
        }"
      />
    </template>

    <template #content-bottom>
      <div class="border-t border-border-light text-right">
        <UButton variant="link" @click="modelValue = []">
          Очистить выбор
        </UButton>
      </div>
    </template>

    <p class="typo-paragraph-md-medium! text-neutral-default">Тип занятий</p>

    <!-- <div
        v-if="selectedDirections?.length"
        class="absolute -top-2.75 -right-2.75 w-6 h-6 flex justify-center items-center text-white bg-accent-default rounded-full border-2 text-size"
      >
        {{ selectedDirections.length }}
      </div> -->
  </USelectMenu>
</template>

<script lang="ts" setup>
import type { LessonTypeRef } from '~/api'

const directoryStore = useDirectoryStore()
const { lessonTypes } = storeToRefs(directoryStore)

defineOptions({
  name: 'LessonTypesDropdown',
})

defineProps<{
  ui?: {
    root?: string
  }
}>()

const modelValue = defineModel<LessonTypeRef[]>({
  required: true,
})

const isLessonTypeSelected = (item: LessonTypeRef) => {
  return modelValue.value.some((d: LessonTypeRef) => d?.id === item.id)
}
</script>

<style></style>
